import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-confirm',
    template: `
        <h1 mat-dialog-title>{{ data.title }}</h1>
        <div mat-dialog-content>
            <p class="dialog-text">{{ data.message }}</p>
        </div>
        <div mat-dialog-actions [align]="'center'">
            <button
            matButton="elevated" 
            color="warn"
            (click)="onClick(false)"
            
            cdkFocusInitial
            >
            {{ data.buttonNo }}
            </button>
            <button
            matButton="elevated" 
            class="green-confirm"
            (click)="onClick(true)"
            cdkFocusInitial
            >
            {{ data.buttonYes }}
            </button>
        </div>
    `,
    styleUrls: ['./dialog.css'],
    standalone: false
})
export class DialogConfirmComponent {
    constructor(
        public dialogRef: MatDialogRef<DialogConfirmComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) { }

    onClick(confirmed: boolean): void {
        this.dialogRef.close(confirmed);
    }
}
